import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AssessmentType, IAssessmentTypeList } from '../models/assessment-type';
import { AssessmentCategoryService } from './assessment-category.service';
import { AssessmentCategory } from '../models/assessment-category';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root'})
export class AssessmentTypeService extends BaseRestService<AssessmentType, IAssessmentTypeList> implements OnDestroy{

  assessmentCategoryChanged: Subscription;

  constructor(http: HttpClient, 
              protected router: Router, 
              private assessmentCategoryService: AssessmentCategoryService) {
    super(AssessmentTypeService, http, 'api/assessmenttypes', 'assessment type', router);

    // enable caching
    this.cacheEnabled = true;

    this.assessmentCategoryChanged = this.assessmentCategoryService.onItemChanged.subscribe((assessmentCategory: AssessmentCategory) => {
      if (this.cache && (this.cache.length > 0)){
        this.cache.filter((i) => i.categoryId === assessmentCategory.id).map((i) => i.category = assessmentCategory);
      }
    });
  }

  ngOnDestroy(){
    this.assessmentCategoryChanged?.unsubscribe();
  }

  hydrate(item: AssessmentType): Observable<AssessmentType> {
    const hydrate$ = [];
    if ((!item.category) || (item.category.id !== item.categoryId)){
      hydrate$.push(this.assessmentCategoryService.getById(item.categoryId).pipe(take(1), map((category: AssessmentCategory) => {
        item.category = category;
        return item;
      })));
    }
    
    if (hydrate$.length > 0){
      return forkJoin(hydrate$).pipe(take(1), map((_) => {
        return item;
      }));
    }
    else{
      return of(item);
    }
  }

  save(entity: AssessmentType, successMessage?: string) {
    // make sure that any related data objects are 'unset' prior to subject being saved
    entity.category = undefined;
    return super.save(entity, successMessage);
  }
}
